export const AGE_RANGES = {
  '4-6': {
    label: '4-6 meses',
    description: 'Primeras papillas y purés suaves',
    foods: [
      'Papillas de cereales sin gluten',
      'Purés de frutas suaves (manzana, pera, plátano)',
      'Purés de verduras (zanahoria, calabaza, patata)',
      'Potitos específicos 4-6 meses'
    ]
  },
  '6-8': {
    label: '6-8 meses',
    description: 'Introducción de nuevos alimentos',
    foods: [
      'Cereales con/sin gluten',
      'Frutas variadas en puré',
      'Verduras variadas',
      'Pollo en puré',
      'Potitos variados 6-8 meses'
    ]
  },
  '8-12': {
    label: '8-12 meses',
    description: 'Texturas más consistentes',
    foods: [
      'Cereales y pasta pequeña',
      'Frutas troceadas suaves',
      'Verduras en trozos pequeños',
      'Pollo y pescado blanco',
      'Potitos con texturas 8-12 meses'
    ]
  },
  '12+': {
    label: '12+ meses',
    description: 'Transición a alimentos sólidos',
    foods: [
      'Todo tipo de cereales y pasta',
      'Frutas variadas',
      'Verduras variadas',
      'Carnes magras y pescados blancos',
      'Legumbres bien cocidas'
    ]
  }
} as const;

export const getAgeRangeLabel = (ageRange: string): string => {
  return AGE_RANGES[ageRange as keyof typeof AGE_RANGES]?.label || ageRange;
};